// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';
import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

interface Props {
  formValues: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onChangeTwo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCloseModal: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onInfo: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
  fileName: string;
  fileId: string;
  download: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleUploadFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleDeletedFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showFreeboard: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function OnlyNameForm(props: Props): JSX.Element {
  const { data, modalShow, typeCompanyArray, loading } = props.formValues;
  const { fileName, fileId } = props;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Code</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.code || ''}
            name="code"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Type</b> &nbsp;
          </label>
          <Select2
            name="type"
            data={typeCompanyArray.map((item: any): DataSelect2 => {
              return { id: item.id, text: item.name };
            })}
            value={data.type || ''}
            options={{
              placeholder: 'Select option',
            }}
            onChange={props.onChange}
            style={{ width: '80%' }}
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Contact</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.contact || ''}
            name="contact"
            onChange={props.onChange}
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-3">
          <label className="label">
            <b>Phone</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.phone || ''}
            name="phone"
            onChange={props.onChange}
          />
        </div>
        <div className="col-3">
          <label className="label">
            <b>E-mail</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.email || ''}
            name="email"
            onChange={props.onChange}
          />
        </div>
      </div>
      <br />
      <br />
      <br />
      <footer>
        <div className="text-right">
          <div>
            <label>
              <i>This field is required (*)</i>
            </label>
          </div>
        </div>
        <div hidden={!data.id}>
          <button type="button" className="btn btn-primary" onClick={props.onInfo}>
            Dashboard
          </button>
        </div>
        <div>
          {loading && (
            <img className="loading-wdna" alt="loading" src="assets/img/loading-wdna.gif" />
          )}
          <button type="button" onClick={props.onReset} className="btn btn-primary">
            Reset
          </button>
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </div>
      </footer>
      <br />
      <div className="row">
        <ContainerModal
          fullScreenButton={false}
          show={modalShow}
          title="SELECT DASHBOARD"
          modalClass="selector-modal"
          onClose={props.onCloseModal}
          footerButtons={[
            {
              text: 'OK',
              className: 'btn btn-primary',
              onClick: props.onCloseModal,
            },
          ]}
        >
          <div>
            <label className="label">
              <b>Selected File</b>
            </label>
            <div className="input input-file">
              <span className="button">
                <input
                  type="file"
                  id={fileId}
                  name="file"
                  onChange={props.onChangeTwo}
                  required={!props.formValues.id}
                  accept=".json"
                  style={{ width: '75%' }}
                />
                <br />
                <label className="label">
                  <b>Browse</b>
                </label>
                <br />
              </span>
              <div className="cl-element btn-select2-addon">
                <input type="text" id={fileName} placeholder="Include some files" readOnly style={{ width: '55%' }} />
                &nbsp;&nbsp;
                <button
                  type="button"
                  style={{ right: 'unset' }}
                  className="btn btn-default"
                  onClick={props.onHandleUploadFile}
                >
                  Save
                </button>
                <div hidden={!props.formValues.isFile}>
                  <button
                    type="button"
                    style={{ right: '40px', top: '0px' }}
                    className="btn btn-default"
                    onClick={props.onHandleDeletedFile}
                  >
                    Delete
                  </button>
                </div>
              </div>
              <br />
              <label className="label">
                <b>Old File</b>
              </label>
              <div hidden={props.formValues.isFile}>
                <input
                  className="inputNew"
                  style={{ width: '55%' }}
                  type="text"
                  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message
                  size="50"
                  value="No files in server"
                  readOnly
                />
              </div>
              <div hidden={!props.formValues.isFile} className="cl-element btn-select2-addon">
                <input
                  className="inputNew"
                  style={{ width: '55%' }}
                  type="text"
                  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message
                  size="50"
                  value={`company_${data.id}.json` || ''}
                  readOnly
                />
                &nbsp;&nbsp;
                <button
                  type="button"
                  style={{ right: 'unset' }}
                  className="btn btn-default"
                  onClick={props.download}
                >
                  Download
                </button>
                <button
                  type="button"
                  style={{ right: '40px' }}
                  className="btn btn-default"
                  onClick={props.showFreeboard}
                >
                  Show
                </button>
              </div>
            </div>
          </div>
        </ContainerModal>

      </div>
    </fieldset>
  );
}

export default OnlyNameForm;
